var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 8V4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0M5.25 20v-8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-1.5 0M13.25 16a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.499 0 2.75 2.75 0 0 1 5.499 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 14V4a.75.75 0 0 1 1.5 0v10a.75.75 0 0 1-1.5 0M11.25 20v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0M19.25 7a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.499 0 2.75 2.75 0 0 1 5.499 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.25 5V4a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-1.5 0M17.25 20V9a.75.75 0 0 1 1.5 0v11a.75.75 0 0 1-1.5 0"
  })));
};
export default SvgAdjustments;